var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tab-item',{staticClass:"mt-5"},[_c('v-btn',{attrs:{"color":"green lighten-2","dark":"","small":""},on:{"click":_vm.openCie10CPSDialog}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-plus")]),_vm._v(" "+_vm._s(_vm.condiciones.btnText)+" ")],1),_c('h3',{staticClass:"mt-5"},[_vm._v(_vm._s(_vm.condiciones.dialogTitle))]),_c('v-data-table',{attrs:{"items":_vm.items,"headers":[
      {text:'Código CIE10-CPS', value:'code'},
      {text:'Nombre', value:'name'}
    ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }